module.exports = __webpack_public_path__ + "static/media/shape-B.6c64af9a.svg";